import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Table, Select } from "antd";

const { Option } = Select;

class StageEnemiesTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      amplifier: 100,
    };
  }

  handleChange = (value) => {
    const amplifier = this.props.difficulties[value[0] - 1].stage_amp;
    this.setState({ amplifier: amplifier });
  };

  getStars() {
    const stars = [];
    if (this.props.difficulties) {
      this.props.difficulties.forEach(function (star) {
        stars.push(<Option value={star.difficulty}>{star.difficulty}</Option>);
      });
    }

    return stars;
  }

  getAmplifier(base_amp) {
    return Math.round((base_amp * this.state.amplifier) / 100);
  }

  render() {
    // const innerHeight = this.props.viewportHeight;

    this.columns = [
      {
        title: (
          <div>
            <Select
              defaultValue="1 Star"
              style={{ width: 90 }}
              onChange={this.handleChange}
            >
              {this.getStars()}
            </Select>
          </div>
        ),
        width: 100,
        dataIndex: "img",
        key: "img",
        align: "center",
        render: (text, record) => (
          <Link
            to={
              "/enemyinfo/" +
              record.enemy_no +
              "/" +
              record.enemy_name_en +
              "/" +
              this.getAmplifier(record.amplification)
            }
          >
            <img
              src={
                "https://onestoppress.com/images/edi_" +
                record.enemy_no +
                ".png"
              }
              alt={record.enemy_name_en}
            />
          </Link>
        ),
      },
      {
        title: "Amplifier",
        width: 80,
        dataIndex: "amplification",
        key: "amplification",
        render: (text, record) => (
          <div>{this.getAmplifier(record.amplification)}%</div>
        ),
      },
      {
        title: "Number",
        dataIndex: "number",
        key: "number",
        width: 70,
        align: "left",
      },
      {
        title: "Base Trigger",
        dataIndex: "base_trigger",
        key: "base_trigger",
        width: 100,
        align: "left",
      },
      {
        title: "Time Trigger (s)",
        dataIndex: "time_trigger",
        key: "time_trigger",
        width: 120,
        align: "left",
      },
      {
        title: "Spawn Interval (s)",
        dataIndex: "spawn_interval",
        key: "spawn_interval",
        width: 130,
        align: "left",
      },
      {
        title: "Is Boss",
        dataIndex: "is_boss",
        key: "is_boss",
        width: 80,
        align: "left",
      },
    ];

    return (
      <Table
        columns={this.columns}
        dataSource={this.props.enemies}
        scroll={{ x: 750 }}
        size="small"
        loading={false}
        locale={{
          emptyText: (
            <div>
              View all enemies in this stage.
              <p></p>
              Click in to look up their specific statistics!
            </div>
          ),
        }}
        pagination={{
          position: "bottom",
          hideOnSinglePage: true,
          showQuickJumper: true,
          showSizeChanger: true,
          defaultPageSize: 25,
          pageSizeOptions: ["25", "50", "100", "600"],
        }}
      />
    );
  }
}

export default StageEnemiesTable;



// WEBPACK FOOTER //
// ./src/components-kr/table/StageEnemiesTable.js